
import FilterPrev from '@/components/svg/FilterPrev.vue';
import FilterNext from '@/components/svg/FilterNext.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'MyPagination',
    components: { FilterNext, FilterPrev },
    props: {
        page: {
            type: Number,
            required: true
        },
        totalPage: {
            type: Number,
            required: true
        }
    },
    methods: {
        clickHandler(page) {
            this.$emit('click-handler', page);
        }
    },
    computed: {
        ...mapGetters({
            isFarmacie: 'global/getIsFarmacie'
        }),
        limitedPages() {
            const pages = [];
            if (this.totalPage <= 7) {
                // Если страниц 7 или меньше, показываем все страницы
                for (let i = 1; i <= this.totalPage; i++) {
                    pages.push(i);
                }
            } else {
                // Логика для большего количества страниц
                if (this.page <= 4) {
                    for (let i = 1; i <= 5; i++) {
                        pages.push(i);
                    }
                    pages.push('...', this.totalPage);
                } else if (this.page >= this.totalPage - 3) {
                    pages.push(1, '...');
                    for (let i = this.totalPage - 4; i <= this.totalPage; i++) {
                        pages.push(i);
                    }
                } else {
                    pages.push(1, '...');
                    for (let i = this.page - 2; i <= this.page + 2; i++) {
                        pages.push(i);
                    }
                    pages.push('...', this.totalPage);
                }
            }
            return pages;
        }
    }
};
